
import Vue from 'vue';
import { Component, Prop, Model, Watch } from 'vue-property-decorator';
import { tUi } from '@/utils/translate';

@Component({
  name: 'RepsolDialog',
})
export default class RepsolDialog extends Vue {
  @Model()
  public show!: boolean;
  @Prop()
  public title!: string;
  @Prop()
  public leftButtonText!: string;
  @Prop()
  public rightButtonText!: string;
  @Prop()
  public subtitle1!: string;
  @Prop()
  public subtitle2!: string;
  @Prop()
  public canClose!: boolean;

  translate(value: string, params?: Record<string, unknown>): string {
    return tUi(value, params);
  }

  showDialog = false;

  @Watch('showDialog')
  showDialogEvent(show: any) {
    this.$emit('show', show);
  }

  @Watch('show')
  showDialogInternalEvent() {
    this.showDialog = this.show;
  }

  leftButtonClicked() {
    this.$emit('leftButtonClicked');
  }
  rightButtonClicked() {
    this.$emit('rightButtonClicked');
  }
}

Vue.component('repsol-dialog', RepsolDialog);
